import * as model from "@/model/adm/DataField";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.DataField(), newFilter)
    .withStates({idReport: 2}) //TODO load at the application start
    .buildStore()
